import React from 'react';

import { ToastContainer } from 'react-toastify';

import Providers from './components/Providers';
import Layout from './layouts/Layout';

const App = () => {
    return (
        <Providers>
            <Layout />
            <ToastContainer
                position="top-center"
            />
        </Providers>
    );
};

export default App;
